// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dm93HnZMIdajkCBZc0fH","buttons":"cVbEYEFZKLsa5tmb_4S2"};